export default __webpack_public_path__ + "static/media/insuranceglow.69d3346f.png";